import {InsideDrawerApplication} from '../inside-drawer.application';
import {ComponentID, IChatSpecificParams, ChatOpenMode} from '@sparkware/uc-sdk-core';



export class ChatApplication extends InsideDrawerApplication {

    protected _shouldMinimizeOnDrawerClose(): boolean {
        return !this.isDisposed;
    }

    protected _getMiniatureComponentID(): ComponentID {
        return 'CR_CHAT_BUBBLE';
    }

    get minOverlayZIndex(): number | null {
        const chatSpecificParams = this._openAppData.launchInfo.appSpecificParameters as IChatSpecificParams;
        if(chatSpecificParams?.openMode === ChatOpenMode.SOF) {
            return this.services.sdk.overlayZIndex.OMG + 1
        }
        return null;
    }

}


